import script from "./AppLinkResolver.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLinkResolver.vue?vue&type=script&setup=true&lang=js"

import "./AppLinkResolver.vue?vue&type=style&index=0&id=21f86b8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f86b8e"]])

export default __exports__